import { render, staticRenderFns } from "./userProfileEntityDataWorkflows.vue?vue&type=template&id=35807b78&scoped=true"
import script from "./userProfileEntityDataWorkflows.vue?vue&type=script&lang=js"
export * from "./userProfileEntityDataWorkflows.vue?vue&type=script&lang=js"
import style0 from "./userProfileEntityDataWorkflows.vue?vue&type=style&index=0&id=35807b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35807b78",
  null
  
)

export default component.exports